import React from "react";
import { ActionIcon, Box, Button, Group, Stack, Text } from "@mantine/core";
import { IconUsersGroup, IconX } from "@tabler/icons-react";
import styles from "./DuplicatesBanner.module.css";

interface DuplicatesBannerProps {
  /** Number of potential-duplicate groups found. */
  count: number;
  onReview: () => void;
  onDismiss: () => void;
}

/**
 * Banner surfaced on the clients list when the backend flags potential
 * duplicate records. Offers a one-click jump to the review-and-merge screen.
 */
const DuplicatesBanner: React.FC<DuplicatesBannerProps> = ({
  count,
  onReview,
  onDismiss,
}) => {
  return (
    <Box className={styles.banner}>
      <Group justify="space-between" wrap="nowrap" align="flex-start">
        <Group gap="md" wrap="nowrap" align="flex-start">
          <Box className={styles.iconWrap}>
            <IconUsersGroup size={22} />
          </Box>
          <Stack gap={2}>
            <Text fw={700} size="md">
              We found {count} potential duplicate{count === 1 ? "" : "s"}
            </Text>
            <Text size="sm" c="dimmed">
              Review records that share a name, phone number, or email and merge
              them to keep your client list clean.
            </Text>
          </Stack>
        </Group>
        <Group gap="xs" wrap="nowrap">
          <Button color="var(--brand-teal)" onClick={onReview}>
            Review Duplicates
          </Button>
          <ActionIcon
            variant="subtle"
            color="gray"
            onClick={onDismiss}
            aria-label="Dismiss duplicates banner"
          >
            <IconX size={18} />
          </ActionIcon>
        </Group>
      </Group>
    </Box>
  );
};

export default DuplicatesBanner;
